import {LocalizedText} from "crqlar-react-common/dist/models/common/localizedText.model";
import {SurveyQuestion} from "crqlar-react-common/dist/models/survey/surveyQuestion.model";
import {getSurveyQuestionTypeFacts} from "../shared/surveyQuestionTypeFacts";

export const supportsScaleLabels = (question: SurveyQuestion | undefined) => (
    !!getSurveyQuestionTypeFacts(question?.type)?.scale
);

const hasText = (text: LocalizedText | undefined) => (
    !!text && Object.values(text).some(value => !!value?.trim())
);

const hasScaleLabels = (question: SurveyQuestion) => (
    hasText(question.lowLabel) || hasText(question.highLabel)
);

export const scaleLabelsVisible = (
    question: SurveyQuestion | undefined,
    sessionOverrides: Record<string, boolean>
) => {
    if (!question || !supportsScaleLabels(question)) return false;

    const override = question.id ? sessionOverrides[question.id] : undefined;
    if (override !== undefined) return override;

    return hasScaleLabels(question);
};

export const clearScaleLabels = (): Partial<SurveyQuestion> => ({
    lowLabel: undefined,
    highLabel: undefined,
});
